import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { createUser } from '../../actions/profile/apiRequests';
import { COMPANY_TESTER } from '../../constants/userRoles';
import { COUNTRY as defaultCountry } from '../../constants/defaults';
import withRoleRestrictions from '../shared/withRoleRestrictions';
import withEulaRestrictions from '../license/withEulaRestrictions';
import ProfilePage from './ProfilePage';
import { ADMINS } from '../../constants/userRoles';


export class AddUserPage extends React.Component {
  constructor(props) {
    super(props);
    this.state={
      userId: null
    };
    this.onSave = this.onSave.bind(this);
    this.onCancel = this.onCancel.bind(this);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  onSave(user) {
    return createUser(user)
      .then(user => this.setState({ userId: user.id }));
  }

  onCancel() {
    this.props.history.goBack();
  }

  render() {
    const { userId } = this.state;
    const { location={} } = this.props;
    const {
      isSpruceAdmin,
      isCompanyUser,
      companyId,
      companyName,
      timeZoneId,
    } = this.props.currentUser;

    return (
      <Choose>
        <When condition={userId}>
          <Redirect to={{
            pathname: `/users/${userId}`,
            state: {
              created: true
            }
          }}/>
        </When>
        <Otherwise>
          <ProfilePage
            profile={{
              role: COMPANY_TESTER,
              country: defaultCountry,
              companyId: isSpruceAdmin ? location.state && location.state.companyId : companyId,
              companyName: isSpruceAdmin ? null : companyName,
              timeZoneId,
            }}
            editLoginInfo={true}
            editUom={false}
            editSignature={false}
            passwordRequired={true}
            editEmail={true}
            editRole={true}
            editCompany={isSpruceAdmin}
            newUser={true}
            companyUser={isCompanyUser}
            onSave={this.onSave}
            onCancel={this.onCancel}
            hasActiveCompanyAdmin={isCompanyUser}
            {...this.props}
          />
        </Otherwise>
      </Choose>
    );
  }
}

AddUserPage.propTypes = {
  history: PropTypes.object,
  location: PropTypes.object,
  currentUser: PropTypes.object
};

const mapStateToProps = ({ profile }) => ({
  currentUser: profile
});

export default connect(mapStateToProps)(
  withEulaRestrictions(withRoleRestrictions(AddUserPage, ADMINS))
);



// WEBPACK FOOTER //
// src/components/profile/AddUserPage.jsx